module.exports = __webpack_public_path__ + "img/firefox.6c6ee4cf.png";